module.exports = "//static.hsappstatic.net/LoginUI/static-1.15098/img/SUI_desktop.svg"